import React, { FC, PropsWithChildren } from "react";
import "./index.scss";

export type RadioGroupProps = PropsWithChildren<{ className?: string }>;
export const RadioGroup: FC<PropsWithChildren> = ({ children }) => {
  return <div className="radio-group inline">{children}</div>;
};

export default RadioGroup;
